module.exports = __webpack_public_path__ + "img/icon_3_32.13030c7d.png";